import Icon from '@ant-design/icons';

const Heading1 = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.66675 13.6667V2.43552H3.15988V7.48936H7.64592V2.43552H9.14307V13.6667H7.64592V8.74102H3.15988V13.6667H1.66675Z"
        fill="currentColor"
      />
      <path
        d="M10.1425 13.669V12.6839H11.844V8.12563L10.1335 9.39728V8.21518L11.638 7.13159H12.9634V12.6839H14.3336V13.669H10.1425Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Heading1Icon = (props: any) => <Icon component={Heading1} {...props} />;
